export class SubscriptionCreationData {
    public departmentCode: string | null = null;
    public departmentCountry: string | null = null;
    public departmentCity: string | null = null;
    public lastName: string | null = null;
    public firstName: string | null = null;
    public middleName: string | null = null;
    public birthDate: Date | null = null;
    public sequence: string | null = null;
    public isApplicationPresent: boolean = false;
}
